import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';

function ResourceMaterials({ data }) {
    return (
        <div key={data.documentId} className="resource-materials">
            <div className="views-row views-row-4 views-row-even">

                <article id="node-81" className="node node-resource-materials-band node-promoted node-teaser clearfix" about="/node/81" typeof="sioc:Item foaf:Document">

                    <div className="container-fluid photo-div background-full-width"  id="resourceMaterials">
                        {/*style={{ maxWidth: "1280px" }}*/}

                        <div className="row">

                            <h2 className="section-headline-small">
                                MATERIALS
                            </h2>
                            <hr style={{ borderTop: "2px solid #333" }} />
                            {/*previous color    #c9cacb*/}
                        </div>

                        <div className="row">
                            <div className="container-fluid album-container resource-material-container no-padding" >

                                {data.resourceMaterials.map((resourceMaterial, resourceMaterialIdx) => (
                                    <div key={ resourceMaterialIdx } className="col-sm-3 col-sm-offset-0 col-xs-10 col-xs-offset-1 no-padding resource-material-column">
                                        <div className="resource-material">
                                            <img alt="resource-material" className="img-responsive preview-img center-align" src={ resourceMaterial.thumbnail.url } />
                                        </div>

                                        <div className="resource-material-text">

                                            <div className="resource-material-title">
                                                <p className="body-text">
                                                    { resourceMaterial.name }
                                                </p>
                                            </div>

                                            {resourceMaterial.downloads.map((download, downloadIdx) => (
                                                <div key={ downloadIdx } className="resource-material-downloads">
                                                    <a className="light-blue-text" href={ download.file.url } download="" target="_blank">
                                                        { download.text }
                                                    </a>
                                                    &nbsp;
                                                </div>
                                            ))}
                                        </div>

                                    </div>
                                ))}

                            </div>
                        </div>

                    </div>

                </article>

            </div>
        </div>
    );
}

export default ResourceMaterials;
